var _defs, _path, _g, _g2, _polygon, _polygon2, _polygon3, _path2, _g3, _polygon4, _polygon5, _polygon6, _rect, _g4, _g5, _g6, _g7, _g8, _g9, _g10;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgButHandBleu(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 150 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #fff;\n      }\n\n      .st1 {\n        fill: #4970b5;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M75.1,77.1c-14.9,0-27-12.1-27-27s12.1-27,27-27,27,12.1,27,27-12.1,27-27,27ZM75.1,23.8c-14.5,0-26.2,11.8-26.2,26.2s11.8,26.2,26.2,26.2,26.2-11.8,26.2-26.2-11.8-26.2-26.2-26.2Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "65.7 38.1 75.1 43.5 75.1 55.5 66.9 60.6 57.5 55.5 57.2 44.1 65.7 38.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M66.9,61.1l-9.8-5.3-.4-11.9,9-6.2,9.8,5.6v12.4l-8.6,5.4ZM57.9,55.3l9,4.9,7.8-4.9v-11.5l-8.9-5.1-8.2,5.7.4,11Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "st1",
    points: "74.9 28.7 69.8 29.9 65.8 38.1 75.1 43.5 84.2 38.1 80.2 29.9 74.9 28.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M75.1,44l-9.8-5.7,4.2-8.8,5.4-1.2,5.6,1.2,4.2,8.8-9.6,5.7ZM66.3,38l8.8,5.1,8.6-5.1-3.7-7.8-5-1.1-4.9,1.1-3.7,7.8Z"
  }))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "56.9 44.4 52 41.1 54.7 32.3 64.6 26.7 70 29.5 69.6 30.2 64.7 27.6 55.4 32.8 52.9 40.7 57.4 43.7 56.9 44.4"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "52.2 58.8 48 50.1 52.1 40.7 52.8 41.1 48.9 50.1 52.6 57.7 57.4 55.1 57.7 55.8 52.2 58.8"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "64.7 73.3 55.2 68.4 52 58.4 52.8 58.2 55.9 67.8 64.6 72.4 69.6 69.4 70 70 64.7 73.3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M74.9,77.1c-14.9,0-27-12.1-27-27s12.1-27,27-27,27,12.1,27,27-12.1,27-27,27ZM74.9,23.8c-14.5,0-26.2,11.8-26.2,26.2s11.8,26.2,26.2,26.2,26.2-11.8,26.2-26.2-11.8-26.2-26.2-26.2Z"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "84.4 38.1 75.1 43.5 75.1 55.5 83.2 60.6 92.5 55.5 92.8 44.1 84.4 38.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M83.2,61.1l-8.5-5.4v-12.4l9.7-5.6,8.9,6.2-.4,11.9-9.7,5.3ZM75.5,55.3l7.7,4.9,8.9-4.9.4-11-8.1-5.6-8.8,5.1v11.5Z"
  }))), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "93.1 44.4 92.6 43.7 97.1 40.7 94.6 32.8 85.3 27.6 80.4 30.2 80 29.5 85.4 26.7 95.3 32.3 98 41.1 93.1 44.4"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "97.8 58.8 92.3 55.8 92.6 55.1 97.4 57.7 101.1 50.1 97.2 41.1 97.9 40.7 102 50.1 97.8 58.8"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "85.3 73.3 80 70 80.4 69.4 85.4 72.4 94.1 67.8 97.2 58.2 98 58.4 94.8 68.4 85.3 73.3"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "st1",
    x: 81.1,
    y: 73.9,
    width: 4.8,
    height: 0.8,
    transform: "translate(-28.2 68.8) rotate(-38.9)"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "st1",
    points: "69.8 69.6 75.1 71.1 80.2 69.6 83.6 60.6 74.9 55.5 67 60.6 69.8 69.6 75.1 71.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M75.1,71.5l-5.6-1.7-2.9-9.4,8.3-5.4,9.2,5.4-3.5,9.4-5.4,1.7ZM70.1,69.2l5,1.5,4.8-1.5,3.2-8.4-8.2-4.8-7.4,4.8,2.6,8.4Z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M81.5,24.2c6.8,1.2,12.9,7.6,12.9,7.6l.4.7-9.6-5.3-.2-.2-3.5-2.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M96,33.5l-11.1-6.1-4.9-3.9,1.5.3c6.8,1.2,12.9,7.4,13.1,7.7h0c0,0,1.3,2,1.3,2ZM85.4,26.8l7.6,4.1c-1.8-1.6-5.7-4.7-9.9-6l2.3,1.9Z"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M68.3,24.2c-6.8,1.2-13,7.9-13,7.9v.4l9.3-5.3.2-.2,3.5-2.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M55,33.1v-1.2h.1c.3-.4,6.4-6.9,13.2-8.1l1.5-.3-4.9,4-9.9,5.6ZM66.7,25c-4.2,1.3-8,4.4-9.9,6.2l7.6-4.3,2.3-1.9Z"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M80,30.5l-5.4-1.6-5.1,1.6-5.1-3.3,3.7-3s7.4-2,13.5,0l3.5,3-5.1,3.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M80.1,30.9l-5.5-1.6-5.1,1.6-5.7-3.7,4.2-3.4h0c.3-.1,7.6-2,13.7,0h0s4,3.4,4,3.4l-5.7,3.7ZM74.6,28.5l5.3,1.6,4.5-2.9-3-2.6c-5.5-1.8-12.3-.2-13.1,0l-3.2,2.6,4.5,2.9,5-1.6Z"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M68.3,75.8c-6.8-1.2-12.9-7.6-12.9-7.6l9.2,4.6.2.2,3.5,2.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M69.8,76.5l-1.5-.3c-6.8-1.2-12.9-7.4-13.1-7.7l-1.6-1.6,11.3,5.7,4.9,3.9ZM57.8,69.9c2,1.7,5.3,4.1,8.9,5.2l-2.3-1.9-6.6-3.3Z"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M81.5,75.8c6.8-1.2,12.9-7.6,12.9-7.6l-9.2,4.6-.2.2-3.5,2.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M80,76.5l5-4,11.2-5.6-1.6,1.6c-.3.3-6.3,6.5-13.1,7.7l-1.5.3ZM85.4,73.2l-2.3,1.9c3.6-1.1,6.9-3.5,8.9-5.2l-6.6,3.3Z"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M69.8,69.5l5.4,1.6,5.1-1.6,5.1,3.3-3.7,3s-7.4,2-13.5,0l-3.5-3,5.1-3.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M74.4,77.1c-2,0-4.3-.2-6.3-.9h0s-4-3.4-4-3.4l5.7-3.7,5.5,1.6,5.1-1.6,5.7,3.7-4.2,3.4h0c-.2,0-3.4.9-7.4.9ZM68.3,75.5c5.5,1.8,12.3.2,13.1,0l3.2-2.6-4.5-2.9-5,1.6-5.3-1.6-4.5,2.9,3,2.6Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgButHandBleu);
export default __webpack_public_path__ + "static/media/but_hand_bleu.556aee55532c49eb36ee69723c314732.svg";
export { ForwardRef as ReactComponent };